const baseURL = 'https://pro.ip-api.com/json';
const auth = '?key=6qJkpvnUuUHzTqG'; // cspell:disable-line
const url = `${baseURL}${auth}`;

export default function fetchGeolocation() {
  return fetch(url)
    .then((res) => res.json());
}
